// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"72b7e766","131":"34d1bfa9","164":"eca1647c","196":"84a88cdf","236":"4fb230f0","603":"70642046","626":"bf5a71ad","694":"c8acb3ef","753":"0b46a633"}[chunkId] + ".chunk.js";
};